export enum SendToEnum{
    Associates = 'Associates',
    Vendors = 'Vendors',
    Customers = 'Customers',
    Other = 'Others'
}

export enum SendEnum {
    Associates = 'Associates',
    Vendors = 'Vendors',
    Customers = 'Customers'
}

